// Need to access to stuff from Experience.js
import CameraControls from 'camera-controls'
import Experience from './Experience.js'
import * as THREE from 'three'

// Initialize CameraControls
CameraControls.install({ THREE: THREE })

export default class Camera {
    constructor() {
        // this.experience = window.experience
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas

        this.setInstance()
        this.setCameraControls()

        document.addEventListener("placeholderClicked", (event) => {
            this.locationId = event.detail.placeholder.id;
        })
    }

    setInstance() {
        this.instance = new THREE.PerspectiveCamera(
            35,
            this.sizes.width / this.sizes.height,
            0.01,
            100
        )
        // this.instance = new THREE.OrthographicCamera()
        this.instance.position.set(6, 2.5, 8)
        // this.init()
        // console.log(this.instance.position)
        this.scene.add(this.instance) // Add the camera to the scene
    }

    setCameraControls() {
        this.controls = new CameraControls(this.instance, this.canvas)
        // this.controls.smoothTime = 1 // Actually these are set in CameraTransition.js
        // this.init()
    }

    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update() {
        // console.log(`Camera position: ${this.instance.position.x}, ${this.instance.position.y}, ${this.instance.position.z}`);
        // this.controls.update(this.experience.time.delta) // It's being overriden by CameraTransition.js where we also update the controls.
    }
}
